import { Injectable } from '@angular/core';

import { ImageRatioEnum, PositionEnum } from '@seb/web-design-system/core';

import { PushCardImageRatioEnum, PushCardMediaConfigEnum, PushCardTextConfigEnum } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ImageRatioMapper {
  public static mapPosition(positionConfig: PushCardTextConfigEnum | PushCardMediaConfigEnum): PositionEnum {
    switch (positionConfig) {
      case PushCardTextConfigEnum.LEFT:
      case PushCardMediaConfigEnum.LEFT:
        return PositionEnum.left;
      case PushCardTextConfigEnum.CENTER:
        return PositionEnum.center;
      case PushCardMediaConfigEnum.BOTTOM:
        return PositionEnum.bottom;
      case PushCardMediaConfigEnum.RIGHT:
        return PositionEnum.right;
      case PushCardMediaConfigEnum.TOP:
        return PositionEnum.top;
      default:
        return PositionEnum.left;
    }
  }
  public static mapImageRatio(pushImageRatio: PushCardImageRatioEnum | ImageRatioEnum): ImageRatioEnum {
    switch (pushImageRatio) {
      case PushCardImageRatioEnum.R1_1:
        return ImageRatioEnum.r1_1;
      case PushCardImageRatioEnum.R4_3:
        return ImageRatioEnum.r4_3;
      case PushCardImageRatioEnum.R16_9:
        return ImageRatioEnum.r16_9;
      case PushCardImageRatioEnum.R9_16:
        return ImageRatioEnum.r9_16;
      case PushCardImageRatioEnum.R21_9:
        return ImageRatioEnum.r21_9;
      case PushCardImageRatioEnum.R3_4:
        return ImageRatioEnum.r3_4;
      case PushCardImageRatioEnum.R9_21:
        return ImageRatioEnum.r9_21;
      default:
        return undefined;
    }
  }
}
